module.exports = __webpack_public_path__ + "img/img-aa858367.6c438579.png";